import styles from "./MountSide2C1_Reusable.module.css";
import React, { useImperativeHandle, useRef, useState } from "react";
import domtoimage from "dom-to-image";
import html2canvas from "html2canvas-support-css";
import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";
import EditScreenSelector from "../../Reusables/EditScreenSelector";
const MountSide2C1Reusable = React.forwardRef(
  (
    {
      index,
      callback,
      callbackPreviewChange,
      state,
      image_selection_popup,
      //new stuff
      saveThisProduct,
      changeCopyDetails,
      selectedCopyDetails,
      currentPageNumber,
      totalPageNumber,
      confirmEdits,
      generatePreviewsAtBottom,
      preview_copied_image,
    },
    ref
  ) => {
    const { imageRight } = state;

    const previewRef = useRef(null);

    const changeState = (key, value) => {
      state[key] = value;
      callback(state);
    };

    const changePreview = async (id) => {
      console.log("changed preview image");
      console.log(document.getElementById(id));
      try {
        let elementToCapture;
        if (id) {
          elementToCapture = document.getElementById(id);
          console.log(document.getElementById(id));
        } else {
          elementToCapture = previewRef.current.querySelector("img");
        }
        const blob = await domtoimage.toBlob(elementToCapture, {
          bgcolor: "white",
        });
        console.log("saving image again");
        const file = new File([blob], "image.png", { type: "image/jpg" });

        // const imgElement = new Image();
        // const objectURL = URL.createObjectURL(file);
        // imgElement.src = objectURL;
        // document.body.appendChild(imgElement);

        return file;
      } catch (e) {
        console.log(e);
        return false;
      }
    };

    useImperativeHandle(ref, () => ({
      changePreview,
    }));

    const uploadImage = (num, id) => {
      if (imageRight !== "") return;
      image_selection_popup(index, 1, id);
    };
    const [previewImage, setPreviewImage] = useState("");
    const divRef = useRef(null);

    const copyImageToPreview = () => {
      html2canvas(divRef.current, {
        logging: true,
        letterRendering: 1,
        allowTaint: false,
        useCORS: true,
      }).then((canvas) => {
        // create an image from the canvas
        setPreviewImage(canvas.toDataURL());
      });
    };

    const [imageRightStyle, setImageRightStyle] = useState({
      width: "426px",
      height: "284px",
      objectFit: "cover",
    });
    const [preview, setPreview] = useState(false);

    const checkAspectRatio = (event, setMethod) => {
      const image = event.target;
      if (image.naturalWidth > image.naturalHeight) {
        setMethod({ width: "426px", height: "284px", objectFit: "cover" });
      } else {
        setMethod({ width: "284px", height: "426px", objectFit: "cover" });
      }
    };
    //new 1
    const copyOptions = [];
    for (let i = 1; i < currentPageNumber; i++) {
      copyOptions.push(i + "個目と同じ");
    }
    copyOptions.push("別のデザインで作る");
    // let copySelected =
    //   selectedCopyDetails === currentPageNumber
    //     ? currentPageNumber + "個目の写真"
    //     : selectedCopyDetails+"個目の写真";
    let copySelected = selectedCopyDetails + "個目の写真";
    const extractNumber = (s, currentPageNumber, totalPageNumber) => {
      for (let i = totalPageNumber; i > 0; i--) {
        if (s.includes(i)) {
          return i;
        }
      }
      return currentPageNumber;
    };
    return (
      <div className={styles.main_div}>
        <div className={styles.top_hr}></div>
        <div className={styles.header_section_main}>
          {currentPageNumber === 1 && (
            <div name="編　集" className={styles.header_section}>
              編　　集
            </div>
          )}

          {totalPageNumber > 1 && (
            <div
              className={styles.header_number}
              name={"editsection" + currentPageNumber}
            >
              {currentPageNumber + "個目"}
            </div>
          )}
        </div>
        {currentPageNumber > 1 && (
          <div className={styles.multi_page_selector_wrapper}>
            <div className={styles.multi_page_selector}>
              <EditScreenSelector
                takeupspace={true}
                options={copyOptions}
                callback={(value) => {
                  console.log(value);
                  changeCopyDetails(
                    extractNumber(value, currentPageNumber, totalPageNumber),
                    index
                  );
                  // changeState("sec03textbox", value);
                  // setSec03textbox(value);
                }}
                selected={copySelected}
              />
            </div>
          </div>
        )}
        {selectedCopyDetails === currentPageNumber && (
          <>
            <div className={styles.choice_section}>
              <div className={styles.choice_section_info}>
                1.ギャラリーから写真を2枚選択してください。
              </div>
              <div className={styles.choice_section_info_paragraph}>
                ※横写真は横向き、縦写真は縦向きで挿入されます。
              </div>
              <div className={styles.upload_section_main_div}>
                <div
                  onClick={(event) => {
                    uploadImage();
                  }}
                  className={styles.upload_image_placeholder}
                >
                  <img
                    className={styles.upload_image_gallery_icon}
                    src={gallery_icon}
                    alt="top_gallery"
                  />

                  <div className={styles.upload_image_placeholder_text}>
                    写真選択
                  </div>
                </div>
              </div>
            </div>
            <div ref={divRef} className={styles.image_section_main}>
              <div className={`${styles.image_section_single_main}`}></div>

              <div
                className={`${styles.image_section_single_main} ${styles.ss1}`}
              >
                <div className={styles.image_section_single_image}>
                  {imageRight === "" && (
                    <div
                      onClick={(event) => {
                        uploadImage();
                      }}
                      className={styles.upload_image_placeholder}
                    >
                      <img
                        className={styles.upload_image_gallery_icon}
                        src={gallery_icon}
                        alt="top_gallery"
                      />

                      <div className={styles.upload_image_placeholder_text}>
                        写真選択
                      </div>
                    </div>
                  )}
                  {imageRight !== "" && (
                    <img
                      src={imageRight}
                      onLoad={(event) =>
                        checkAspectRatio(event, setImageRightStyle)
                      }
                      style={imageRightStyle}
                      alt="l-img"
                      crossOrigin="anonymous"
                    />
                  )}
                </div>

                {imageRight !== "" && (
                  <div
                    onClick={() => {
                      console.log("calling callback");
                      changeState("imageRight", "");
                      //   console.log("Cross the image");
                    }}
                    data-html2canvas-ignore="true"
                    className={styles.cross_div}
                  >
                    <ion-icon
                      className={styles.cross_icon}
                      name="close"
                    ></ion-icon>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.bottom_info}>
              実際の商品は台紙枠に合わせて数cmトリミングされます。ご了承ください。
            </div>
          </>
        )}
        {totalPageNumber === 1 && (
          <div className={styles.preview_button_main}>
            <button
              onClick={() => {
                setPreview(true);
                copyImageToPreview();
              }}
              className={styles.preview_button}
            >
              プレビュー
            </button>
          </div>
        )}
        {totalPageNumber > 1 && (
          <div className={styles.edit_done_button_div}>
            <button
              className={styles.edit_done_multiple_button}
              onClick={() => {
                console.log("Save This Page");
                saveThisProduct();
                // downloadBlackBorderImage();
              }}
            >
              {currentPageNumber + "個目を保存"}
            </button>
          </div>
        )}

        {preview && (
          <div ref={previewRef} className={styles.preview_section_main_div}>
            <div className={styles.preview_hr}></div>
            <div className={styles.header_section02}>
              <div className={styles.header_section_header02}>
                イメージプレビュー
              </div>
            </div>
            <div className={styles.preview_image_main}>
              <img
                src={previewImage}
                height={500}
                width={1000}
                alt="preview_image"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
);
export default MountSide2C1Reusable;
